import CountUp from "react-countup";
import styles from "./InfoGraphCounterSection.module.scss";
import infographics_counter from "../../../../constants/graphicsCounter";
import graphics_counter_icons from "../../../../constants/graphicsCounterIcons";

const InfoGraphCounterSection = () => {
  return (
    <section id={styles.infographics_counter_section}>
      <div className={styles.infographics_counter_section}>
        <div className={styles.section_head}>
          <div className={styles.head_icon}>
            <i className="fa-solid fa-chart-pie"></i>
          </div>
          <div className={styles.head_desciption}>
            <h3>Qrafik</h3>
            <p>
              Diaqramda vizual olaraq sizə vacib bir data təqdim edir. Qarşıdan
              gələn yeniləmələri daha asan təhlil edə bilərsiniz
            </p>
          </div>
        </div>
        <div className={styles.infographics_counters_container}>
          {infographics_counter.map((element: any, idx: number) => {
            const icon = graphics_counter_icons[idx];
            return (
              <div key={idx} className={styles.infographics_counter}>
                <div className={styles.info_details}>
                  <h1 className={styles.count}>
                    <CountUp duration={2.75} end={element.count} />
                  </h1>
                  <p className={styles.title}>{element.title}</p>
                </div>
                <div className={styles.counter_icon}>
                  {icon && <img src={icon.icon} alt={"counter icon"} />}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default InfoGraphCounterSection;
